import BaseModel from '@/models/Base';
import Group from '@/models/core/Group';

export default class Topic extends BaseModel {
  static entity = 'topics';

  static autoSerialize = [{ key: 'parent_id', convertTo: 'parent' }];

  static fields() {
    return {
      ...super.fields(),
      name: this.string(''),
      posts: this.number(0),
      color: this.string(''),
      autoSubscribe: this.boolean(false),
      parent_id: this.string(''),
      parent: this.belongsTo(Topic, 'parent_id'),
      groups_collection: this.attr([]),
      members_collection: this.attr([])
    };
  }

  get isTopLevel() {
    return this.parent_id.length === 0;
  }

  get children() {
    return Topic.query()
      .where(topic => {
        return topic.parent_id === this.id;
      })
      .all();
  }

  get groups() {
    const groups = [];

    if (this.groups_collection.length > 0) {
      this.groups_collection.forEach(groupId => {
        let result = Group.query()
          .where(group => {
            return group.id === groupId;
          })
          .first();
        groups.push(result);
      });
    }

    return groups;
  }
}
